import mock from './mock';
import './dashboard/LatestReviewsData';

mock.onAny().passThrough();
